var map = {
	"./bpost.svg": 7063,
	"./chronopost.svg": 3503,
	"./colisprive.svg": 4461,
	"./colissimo.svg": 9594,
	"./dhl.svg": 4652,
	"./dhl_de.svg": 4732,
	"./dhl_express.svg": 8876,
	"./dp.svg": 4506,
	"./dpd.svg": 7161,
	"./dpd_at.svg": 0,
	"./dpd_gb.svg": 5524,
	"./gls_de.svg": 2272,
	"./lettresuivie.svg": 7960,
	"./mondial_relay.svg": 7887,
	"./postat.svg": 7439,
	"./postnl.svg": 9619,
	"./postnl_fulfilment.svg": 5532,
	"./rjp.svg": 1406,
	"./ups.svg": 8172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4919;